import { type FC } from "react";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useTranslation } from "react-i18next";
import { Filter } from "@/partner/shared/components/Filter";

interface PostsFilterProps {
  onCreatePost: () => void;
}

export const PostsFilter: FC<PostsFilterProps> = ({ onCreatePost }) => {
  const { t } = useTranslation();

  return (
    <Filter
      title={t("posts.filter.title")}
      action={
        <Button
          variant="contained"
          color="primary"
          startIcon={<AddIcon />}
          disableElevation
          onClick={onCreatePost}
        >
          {t("common.actions.add")}
        </Button>
      }
      fields={{
        search: true,
      }}
    />
  );
};
